<template lang="pug">
  b-field(:type="{'is-danger': error(input_name, errors)}"
          :message="errorMessageFor(input_name, errors)")
    b-autocomplete(
      data-vv-as="受注経路"
      :name="input_name"
      size="is-small"
      v-model="internalValue"
      :disabled="disabled"
      :loading="loading"
      :data="filteredDataObj"
      field="formattedName"
      open-on-focus
      class="fully-visible-autocomplete"
    )
    | {{ orderRouteName }}

</template>

<script>
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'accepting-order-route-id-input',
    mixins: [ErrorDisplayer],
    data() {
      return {
      }
    },
    props: {
      input_name: {
        type: String,
        required: true
      },
      value: {
        type: Number,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      accepting_order_routes: {
        type: Array,
        required: true,
        default: []
      },
       errors: {
         required: false
       }
    },
    computed: {
      loading(){
        return 0 == this.accepting_order_routes.length
      },
      internalValue: {
        get() {
          return this.value
        },
        set(newVal) {
          var id = this.acceptingOrderRouteId(newVal)
          if (this.value !== id) this.$emit('input', id)
        }
      },
      orderRouteName() {
         var obj = this.accepting_order_routes.filter((route) => {
           return route.id == this.internalValue
         })
         if(obj.length == 1) {
           return obj[0].name
         } else {
           return ""
         }
      },
      filteredDataObj() {
        return this.accepting_order_routes.filter((route) => {
          this.setFormattedName(route)
          return `${route.id} ${route.name}`.indexOf(this.internalValue) >= 0
        })
      }
    },

    methods: {
      orderRouteId(value) {
          var routes = this.accepting_order_routes.filter((route) => {
            if(Number.isInteger(value))
              return route.id === Number(value)
            return route.name === value
          })
         if(routes.length == 1) {
           return routes[0].id
         } else {
           return value
         }
      },
      setFormattedName(route) {
        route.formattedName = route.id + ' ' + route.name
      },
      formatRouteName() {
        this.accepting_order_routes.forEach(route => {
          route.formattedName = route.id + ' ' + route.name
        })
      },
      acceptingOrderRouteId(value) {
        var routes = this.accepting_order_routes.filter((route) => {
          if(route.id == value || route.formattedName == value || route.name == value)
            return true
        })
        if(routes.length == 1) {
          return routes[0].id
        } else {
          return value
        }
      }
    },
    created() {
    },
  }
</script>